import React, { useState, useCallback } from 'react';
import TranslationTooltip from './TranslationTooltip';
import { translateWord, addUserVocabularyWord } from '../../services/api';

const TranslatableText = ({ text, className = '', textColor, topic }) => {
  const [tooltip, setTooltip] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const handleWordClick = useCallback(async (e, rawWord) => {
    e.stopPropagation();
    const cleanWord = rawWord.replace(/^[^a-zA-Z']+|[^a-zA-Z']+$/g, '');
    if (!cleanWord || cleanWord.length < 2) return;

    const rect = e.target.getBoundingClientRect();
    const position = {
      top: rect.bottom + 6,
      left: rect.left + rect.width / 2,
    };

    setTooltip({ word: cleanWord, translation: null, alreadyInVocabulary: false, position });
    setLoading(true);

    try {
      const result = await translateWord(cleanWord);
      setTooltip({
        word: cleanWord,
        translation: result.czech_translation,
        alreadyInVocabulary: result.already_in_vocabulary,
        position,
      });
    } catch {
      setTooltip((prev) => prev ? { ...prev, translation: 'Chyba překladu' } : null);
    } finally {
      setLoading(false);
    }
  }, []);

  const handleSave = useCallback(async () => {
    if (!tooltip || !tooltip.translation) return;
    setSaving(true);
    try {
      await addUserVocabularyWord({
        english_word: tooltip.word,
        czech_translation: tooltip.translation,
        topic: topic || null,
      });
      setTooltip((prev) => prev ? { ...prev, alreadyInVocabulary: true } : null);
    } catch (err) {
      console.error('Failed to save word:', err);
    } finally {
      setSaving(false);
    }
  }, [tooltip, topic]);

  const handleClose = useCallback(() => setTooltip(null), []);

  if (!text) return null;

  const tokens = text.split(/(\s+)/);

  return (
    <span className={className} style={{ color: textColor }}>
      {tokens.map((token, index) => {
        if (/^\s+$/.test(token)) {
          return <React.Fragment key={index}>{token}</React.Fragment>;
        }
        return (
          <span
            key={index}
            onClick={(e) => handleWordClick(e, token)}
            className="translatable-word"
          >
            {token}
          </span>
        );
      })}
      {tooltip && (
        <TranslationTooltip
          word={tooltip.word}
          translation={tooltip.translation}
          loading={loading}
          alreadyInVocabulary={tooltip.alreadyInVocabulary}
          onSave={handleSave}
          saving={saving}
          onClose={handleClose}
          position={tooltip.position}
        />
      )}
      <style>{`
        .translatable-word {
          cursor: pointer;
          border-radius: 2px;
          transition: background-color 0.1s;
        }
        .translatable-word:hover {
          background-color: rgba(59, 130, 246, 0.12);
          text-decoration: underline;
          text-decoration-style: dotted;
          text-underline-offset: 3px;
        }
      `}</style>
    </span>
  );
};

export default TranslatableText;
